// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1w-q";
export var animationRelative = "_1w-p";
export var backdropBlur = "_1w-0";
export var detailLabelCell = "_1w-12";
export var detailTable = "_1w-11";
export var detailValueCell = "_1w-13";
export var docIconBox = "_1w-1d";
export var docIconBoxMd = "_1w-1f";
export var docIconBoxSm = "_1w-1e";
export var docTypeRow = "_1w-16";
export var docTypeRowInner = "_1w-17";
export var dropdownMatchDatePicker = "_1w-3";
export var evidenceCardContent = "_1w-1c";
export var fileUploadSpin = "_1w-j";
export var gorgiasOpenButton = "_1w-15 _1w-d";
export var gorgiasTicketCard = "_1w-14";
export var heroModalFooterButton = "_1w-18";
export var hiddenContainer = "_1w-o";
export var iconPrimary = "_1w-1g";
export var iconQuaternary = "_1w-1i";
export var iconTertiary = "_1w-1h";
export var integrationCard = "_1w-1";
export var integrationLogoBox = "_1w-2";
export var mainColumnSticky = "_1w-1b";
export var maxWidthContainer = "_1w-19";
export var modalContentBody = "_1w-a";
export var modalHeaderImage = "_1w-5";
export var modalImageLabel = "_1w-7";
export var modalImageOverlay = "_1w-6";
export var modalImageSubtitle = "_1w-9";
export var modalImageTitle = "_1w-8";
export var modalImageWrapper = "_1w-4";
export var modalStickyFooter = "_1w-b";
export var removeButton = "_1w-e";
export var sidebarColumn = "_1w-1a";
export var spinner = "_1w-i";
export var timelineLine = "_1w-y";
export var timelineLineBlack = "_1w-10 _1w-y";
export var timelineLineGray = "_1w-z _1w-y";
export var timelineLineHeight = "_1w-x";
export var tlDotActivate = "_1w-u";
export var tlDotActivateAnim = "_1w-t";
export var tlDotHide = "_1w-s";
export var tlDotHideAnim = "_1w-r";
export var tlLineActivate = "_1w-w";
export var tlLineActivateAnim = "_1w-v";
export var uploadHint = "_1w-n";
export var uploadIconBox = "_1w-k";
export var uploadLabel = "_1w-m";
export var uploadText = "_1w-l";
export var uploadZone = "_1w-f";
export var uploadZoneCursorDefault = "_1w-h";
export var uploadZoneCursorPointer = "_1w-g";
export var uploadedFileRow = "_1w-c";
export var viewButton = "_1w-d";